var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ma-6"},[_c('div',{attrs:{"id":"map"},on:{"mousedown":_vm.startDrag,"mouseup":_vm.handleDrag}})]),(_vm.loading)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }